export default __webpack_public_path__ + "static/media/blog-xl-2.a429bad5.png";